import PropTypes from 'prop-types';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';
import { Fragment } from 'react';
import styles from './AvailabilityDisclaimer.module.scss';
import { useSelector } from 'react-redux';
const AvailabilityDisclaimer = ({ className = '', numberOfDaggers = 1 }) => {
  const [t] = useTranslation();
  const AvailabilityForUnmergedCart = useSelector(
    s => !!s?.featureFlag?.PCC_AvailabilityForUnmergedCart
  );
  const daggers = [...Array(numberOfDaggers)].map((_, i) => (
    // eslint-disable-next-line react/no-array-index-key
    <Fragment key={`dagger_${i}`}>&dagger;</Fragment>
  ));
  return (
    !AvailabilityForUnmergedCart && (
      <p className={cx(`mb-0 ${styles['attribute-text']}`, className)}>
        <sup className={`pe-1 ${styles['attribute-dagger']}`}>{daggers}</sup>
        {t('UN_MERGE_AVAILABILITY')}
      </p>
    )
  );
};
AvailabilityDisclaimer.propTypes = {
  className: PropTypes.string,
  numberOfDaggers: PropTypes.number
};
export default AvailabilityDisclaimer;
